// add this to prompt for a refresh
// https://adueck.github.io/blog/caching-everything-for-totally-offline-pwa-vite-react/
import { BehaviorSubject } from 'rxjs';

type UpdateFunction = ((reloadPage?: boolean | undefined) => Promise<void>) | undefined;

export const updateFunction: BehaviorSubject<UpdateFunction> = new BehaviorSubject<UpdateFunction>(undefined);
